import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';

import { getListTotalCount, getListPageCount, getIsLoading } from 'src/reducers/common/listReducer';
import PaginatorWrapper from 'src/components/PaginatorWrapper';

export default connect(
  (state, ownProps) => ({
    count: getListTotalCount(ownProps.reducerName, state),
    pageCount: getListPageCount(ownProps.reducerName, state),
    page: formValueSelector(ownProps.formName)(state, 'page'),
    limit: formValueSelector(ownProps.formName)(state, 'limit'),
    isLoading: getIsLoading(ownProps.reducerName, state)
  }),
  (dispatch, ownProps) => ({
    onClick: page => {
      dispatch(change(ownProps.formName, 'page', page));
    }
  })
)(PaginatorWrapper);
